// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../layers/io.greenhouse.dajoku.ruby/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../layers/io.greenhouse.dajoku.ruby/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body{margin:0 12px}`, "",{"version":3,"sources":["webpack://./app/webpack/javascripts/tinymce/tinymce-extras/margin.scss"],"names":[],"mappings":"AAAA,KACE,aAAA","sourcesContent":["body {\n  margin: 0 12px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
